import { ChertoExperiments } from 'constants/experiments'
import { getChertoExperimentVariation } from 'selectors/experimentSelectors'

/** Impact's UTM source. Cashback, ShopBack and our other affiliates all send traffic through Impact. */
export const AFFILIATE_UTM_SOURCE = 'impact_radius'

/**
 * Impact campaigns of the cashback sites (e.g. ShopBack), as `utm_campaign`: `<program id>_<partner id>`.
 * Only these affiliates are in the GR-5145 experiment.
 */
export const CASHBACK_AFFILIATE_UTM_CAMPAIGNS: ReadonlySet<string> = new Set([
  '23356_11766',
  '23356_1248473',
  '23356_493806',
  '23356_5685201',
  '23356_5301665',
  '23356_4833492',
  '23356_10010',
  '23356_1247203',
  '23356_3858962',
  '23356_22788',
])

/**
 * The customer was referred by a cashback affiliate (GR-5145), so they are eligible for the
 * affiliate hide promo code experiment.
 *
 * A spoofed session is an agent booking for the customer, not the customer seeing checkout.
 */
export function selectIsAffiliatePromoCodeExperimentEligible(state: App.State): boolean {
  return state.utm.source === AFFILIATE_UTM_SOURCE &&
    CASHBACK_AFFILIATE_UTM_CAMPAIGNS.has(state.utm.campaign) &&
    !state.auth.account.isSpoofed
}

/**
 * Affiliate-referred customers in the variant arm cannot add a promo code: the field is hidden and
 * codes are not applied. Ends paying an affiliate commission and a promo discount on the same order.
 */
export function selectIsPromoCodeHiddenForAffiliate(state: App.State): boolean {
  return selectIsAffiliatePromoCodeExperimentEligible(state) &&
    getChertoExperimentVariation(state, ChertoExperiments.affiliateHidePromoCode) === 'variant'
}
